import * as React from 'react';

interface PrimaryButtonProps {
  readonly text: string;
  readonly disabled?: boolean;
}

export function PrimaryButton(props: PrimaryButtonProps) {
  return (
    <button type="submit" className="primary" disabled={props.disabled}>
      {props.text}
    </button>
  );
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/widgets/primary-button.tsx